import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutPayee401kFund } from "./autogen/AutogenLayoutPayee401kFund";

export class Payee401kFund extends AutogenLayoutPayee401kFund {
    override async onLoad() {
        DuplicateId.configureIdTextbox(this.textboxFundCode, {
            tableName: "payee_401k_fund",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}
